module.exports = "<div *ngIf=\"userService\" class=\"container\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3\">\r\n            <h3>Streamingserver synchronisieren</h3>\r\n            <button type=\"button\" class=\"btn btn-success btn-s\" (click)=\"sync()\">Synchronisation durchführen</button>\r\n            {{message}}\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/streaming/streaming.component.html
// module id = 274
// module chunks = 1